var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "ibox sombra-light" }, [
          _c("div", { staticClass: "ibox-title" }, [
            _c("h5", [
              _vm._v("\r\n                    Lista Negra\r\n                "),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ibox-tools" }, [
              _c(
                "button",
                { staticClass: "btn-primary", on: { click: _vm.agregar } },
                [_vm._v("Agregar")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ibox-content" },
            [
              _c("data-table", {
                attrs: {
                  id: _vm.dt.id,
                  datos: _vm.dt.datos,
                  columnas: _vm.dt.columnas,
                  responsive: true,
                  "font-size": 12,
                },
                scopedSlots: _vm._u([
                  {
                    key: "opciones",
                    fn: function (item) {
                      return [
                        _c("div", { staticClass: "dropdown float-right" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-gray btn-sm dropdown-toggle",
                              attrs: {
                                type: "button",
                                "data-toggle": "dropdown",
                                "aria-haspopup": "true",
                                "aria-expanded": "false",
                              },
                            },
                            [
                              _vm._v(
                                "\r\n                                Opciones\r\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "ul",
                            {
                              staticClass: "dropdown-menu dropdown-menu-right",
                            },
                            [
                              _c("li", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:void(0)" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.editar(item.data)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "fal fa-edit" }),
                                    _vm._v(
                                      " Editar\r\n                                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:void(0)" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.eliminar(item.data.id)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fal fa-trash-alt",
                                    }),
                                    _vm._v(
                                      " Eliminar\r\n                                    "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("Modal", {
        ref: "Modal",
        attrs: { tipo: _vm.tipo, nombre: _vm.data.bloqueado },
        on: { accion: _vm.accion },
      }),
      _vm._v(" "),
      _c("ModalDelete", { ref: "ModalDelete", on: { eliminar: _vm.borrar } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }